module.exports = __webpack_public_path__ + "img/farm.181785ee.png";